import { create } from 'zustand'
import { Types } from '@/lib/types'

export const DOUBT_MODAL_SESSION_KEY = "boxwaale-doubt-modal-shown";

export const useModalStore = create((set) => ({
  isOpen: false,
  type: null,
  productContext: null,
  addressContext: null,
  openDoubtModal: ({ automatic = false } = {}) => {
    if (!automatic && typeof window !== "undefined") {
      window.sessionStorage.setItem(DOUBT_MODAL_SESSION_KEY, "true");
    }
    set({ isOpen: true, type: Types.DOUBT_MODAL });
  },
  openProductModal: (product = null) => set({ isOpen: true, type: Types.PRODUCT_MODAL, productContext: product }),
  openTimerModal: () => set({ isOpen: true, type: Types.TIMER_MODAL }),
  openAddressModal: (context = null) => set({ isOpen: true, type: Types.ADDRESS_MODAL, addressContext: context }),
  openSearchModal: () => set({ isOpen: true, type: Types.SEARCH_MODAL }),
  closeModal: () => set({ isOpen: false, type: null, productContext: null, addressContext: null }),
}))
